type GoogleMapsLoadCounterWindow = Window & {
  __GOOGLE_MAPS_LOAD_COUNT__?: number
}

const LOAD_COUNTER_KEY = '__GOOGLE_MAPS_LOAD_COUNT__'

const incrementGoogleMapsLoadCount = (source: string): number => {
  if (typeof window === 'undefined') {
    return 0
  }

  const scopedWindow = window as GoogleMapsLoadCounterWindow
  const currentCount = typeof scopedWindow[LOAD_COUNTER_KEY] === 'number'
    ? scopedWindow[LOAD_COUNTER_KEY]!
    : 0
  const nextCount = currentCount + 1

  scopedWindow[LOAD_COUNTER_KEY] = nextCount
  // eslint-disable-next-line no-console
  console.info(`[GoogleMap] loaded count=${nextCount}`, { source })
  return nextCount
}

export default incrementGoogleMapsLoadCount
